import { Directive, HostListener, input } from '@angular/core';

@Directive({
  selector: '[decimalLimitInput]',
  standalone: true,
})
export class DecimalLimitInputDirective {
  inputType = input.required();
  @HostListener('keydown', ['$event'])
  onInput(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;
    const regex = /^\d*\.?\d{0,5}$/;
    if (this.inputType() === 'number') {
      if (!(regex.test(value) || value === '' || ['ArrowLeft','ArrowRight','Backspace'].includes(event.key))) {
        event.preventDefault();
      }
    }
  }
}
